import React from "react";
import { Modal, Button } from "antd";
import { useTranslation } from "react-i18next";
import Colors from "../../../../../themes/Colors";

const textStyle = { fontSize: "15px", padding: "30px", color: Colors.primaryAccent, margin: 0 };

const EditModeModal = ({ visible, campaign, loading, onCancel, onConfirm }) => {
  const { t } = useTranslation();
  if (!campaign) return null;

  const isPendingOrProposal =
    campaign.payment_status === "pending" || campaign.status === "proposal";

  return (
    <Modal
      title={t("Entering edit mode")}
      visible={visible}
      onCancel={onCancel}
      footer={[
        <Button key="back" onClick={onCancel}>
          {t("Cancel")}
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={onConfirm}>
          {t("Go to edit")}
        </Button>,
      ]}
    >
      {isPendingOrProposal ? (
        <p style={textStyle}>
          {t("When entering the edit mode of a ")}{" "}
          {campaign.status === "proposal"
            ? t("proposal").toLowerCase()
            : t("Campaign").toLowerCase()}{" "}
          <b>{t("some prices may be changed ")}</b>
          {t(
            "(only in cases where screen owners have updated those prices), since this campaign does not have payments generated nor has it been launched, therefore that prices have not been frozen."
          )}
        </p>
      ) : (
        <p style={textStyle}>
          {t(
            "Entering campaign edit mode. This campaign has approved payment, so only elements that do not alter its price can be edited."
          )}
        </p>
      )}
    </Modal>
  );
};

export default EditModeModal;
